import React, { useContext } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Link } from 'gatsby';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import { MenuContext } from '../templates/contexts';

//TODO: add mobile options.

export default function TopNav() {
  const customMenu = useContext(MenuContext);
  const topNavData = useStaticQuery(graphql`
    query topNavQuery {
      nimbuMenu(slug: { eq: "topnav" }) {
        id
        items {
          target_url
          name
        }
      }
    }
  `);

  function handleEnterSearch(event) {
    if (event.key === 'Enter') {
      var currentUrl = window.location.origin;
      var param = document.getElementById('search-input').value;
      var url = currentUrl + '/search?search_query=' + param;
      window.location.href = url;
    }
  }
  return (
    <div
      className={classNames('topnav-wrapper d-print-none', {
        [`topnav-${customMenu?.slug}`]: customMenu?.slug != null,
      })}
    >
      <div className="container">
        <div className="row">
          <div id="menu" className="col-md-12 d-flex justify-content-end align-items-center">
            <ul className="topnav">
              {topNavData.nimbuMenu.items.map((data, index) => (
                <li key={index}>
                  <Link to={`${data.slug === 'homepage' ? '/' : data.target_url}`}>
                    {data.name}
                  </Link>
                </li>
              ))}
            </ul>

            <div className="search-box">
              <input
                className="search-input"
                id="search-input"
                type="text"
                name=""
                placeholder="Zoek en druk enter"
                onKeyPress={handleEnterSearch}
              ></input>
              <Button className="search-btn" variant="link">
                <FontAwesomeIcon icon={faSearch} />{' '}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
